'use client';

import React, { useState } from 'react';
import Link from 'next/link';

const NavMenu: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <nav className="relative">
      <button
        className="text-white text-2xl focus:outline-none"
        onClick={toggleMenu}
        aria-label="Toggle menu"
        aria-expanded={isOpen}
      >
        {isOpen ? (
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        ) : (
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        )}
      </button>
      
      <ul className={`${isOpen ? 'block' : 'hidden'} absolute top-full right-0 bg-white border border-gray-200 p-4 rounded-lg shadow-lg min-w-[200px] z-50`}>
        <li>
          <Link href="/about" className="block py-2 px-4 text-gray-900 hover:text-[#3D669D] hover:bg-blue-50 transition duration-300 rounded">
            About
          </Link>
        </li>
        <li>
          <Link href="/pricing" className="block py-2 px-4 text-gray-900 hover:text-[#3D669D] hover:bg-blue-50 transition duration-300 rounded">
            Pricing
          </Link>
        </li>
        <li>
          <Link href="/contact" className="block py-2 px-4 text-gray-900 hover:text-[#3D669D] hover:bg-blue-50 transition duration-300 rounded">
            Contact
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default NavMenu;
